// plugins/tourRegistry.js
import VTour from '@/components/VTour.vue';
import { tourRegistry } from '../tours/tourState';

export default {
  install(app) {
    // Register the <v-tour> component globally
    app.component('v-tour', VTour);

    // Provide this.$tours across all components
    app.config.globalProperties.$tours = tourRegistry;
  },
};
